import { useMemo } from "react";

import { Skeleton } from "antd";

import { flattenSchemaOptions } from "ServerData/EventSchema/Utils/eventSchemaUtils";

import {
    UpdateContactForm,
    FIELD_TYPE_STRING,
    FIELD_TYPE_NUMBER,
    FIELD_TYPE_BOOLEAN,
    FIELD_TYPE_OBJECT,
    FIELD_TYPE_DATE,
    FIELD_TYPE_LIST,
} from "../../../../../../constants";
import { UpdateContactAttributeFormPanel } from "../../../../../Shared/Components/UpdateContactAttributeFormPanel/UpdateContactAttributeFormPanel";
import { useUpdateContactPanelItems } from "../../../../../Shared/Hooks/useUpdateContactPanelItems/useUpdateContactPanelItems";

const NAME_LABEL = "Property Name";
const TYPE_LABEL = "Data Type";

const LABEL_NUMBER = "Enter Integer or Decimal";
const LABEL_OBJECT = "Property Value in JSON";

type TriggerEventPropertiesProps = {
    loading: boolean;
    id: string;
    eventSchema: any;
};
const CUSTOM_PROP_VALUE_PREPREND = "properties.";

const LABEL_ATTR = "Property Value";
const CUSTOM_PROP_CREATE = "Create Property";

const getLexLabel = (fieldType: string) => {
    switch (fieldType) {
        case FIELD_TYPE_NUMBER:
            return LABEL_NUMBER;
        case FIELD_TYPE_STRING:
            return LABEL_ATTR;
        case FIELD_TYPE_BOOLEAN:
            return LABEL_ATTR;
        case FIELD_TYPE_DATE:
            return LABEL_ATTR;
        case FIELD_TYPE_OBJECT:
            return LABEL_OBJECT;
        case FIELD_TYPE_LIST:
            return LABEL_OBJECT;
        default:
            return "";
    }
};

export function TriggerEventPropertiesFormItems({
    loading,
    id,
    eventSchema,
}: TriggerEventPropertiesProps): JSX.Element {
    const originalOptions = useMemo(() => {
        return flattenSchemaOptions(eventSchema, "", false);
    }, [eventSchema]);

    const propertySelectionName = useMemo(() => {
        return [UpdateContactForm.propertiesListName, id, UpdateContactForm.propertyName];
    }, [id]);
    const propertyValueName = useMemo(() => {
        return [UpdateContactForm.propertiesListName, id, UpdateContactForm.propertyValue];
    }, [id]);

    const propertyTypeName = useMemo(() => {
        return [UpdateContactForm.propertiesListName, id, UpdateContactForm.propertyType];
    }, [id]);

    const { handleFieldChange, handleValueChange, handleTypeChange } = useUpdateContactPanelItems({
        contactAttributes: eventSchema,
        id,
        listNameKey: UpdateContactForm.propertiesListName,
        attributeNameKey: UpdateContactForm.propertyName,
        typeNameKey: UpdateContactForm.propertyType,
        valueNameKey: UpdateContactForm.propertyValue,
        selectionName: propertySelectionName,
        valuesName: propertyValueName,
        typeName: propertyTypeName,
    });

    return (
        <>
            {loading && <Skeleton></Skeleton>}
            {!loading && (
                <UpdateContactAttributeFormPanel
                    attrNameLabel={NAME_LABEL}
                    attrNameFormName={propertySelectionName}
                    attrTypeLabel={TYPE_LABEL}
                    attrTypeFormName={propertyTypeName}
                    attrValueFormName={propertyValueName}
                    createNewText={CUSTOM_PROP_CREATE}
                    originalOptions={originalOptions}
                    createNewPrefix={CUSTOM_PROP_VALUE_PREPREND}
                    handleFieldChange={handleFieldChange}
                    handleValueChange={handleValueChange}
                    handleTypeChange={handleTypeChange}
                    getValueLabel={getLexLabel}
                ></UpdateContactAttributeFormPanel>
            )}
        </>
    );
}
